<template>
  <div>
    <md-card>
      <md-card-content>
        <md-layout md-flex="10">
          <md-layout md-flex="85"></md-layout>
          <button
            class="md-button md-raised md-primary md-button-color md-theme-default heght-1px"
            @click="previousClientView"
          >&laquo; Back</button>
        </md-layout>

        <!-- <img src="http://13.229.240.246/Client/FILE-1536734022.jpg"> -->
        <form novalidate @submit.prevent="validateUser">
          <md-layout md-gutter>
            <md-layout md-flex="40"></md-layout>
            <md-layout md-flex="50">
              <h2>View Contract</h2>
              <md-layout md-flex="10"></md-layout>
            </md-layout>
          </md-layout>
          <hr>

          <md-layout md-gutter>
            <md-layout md-flex="5"></md-layout>
            <h3>Validity From Date:</h3>
            <md-layout md-flex="20"></md-layout>
            <h3>Validity To Date:</h3>
            <md-layout md-flex="20"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Select Contract Type</label>
                <md-select
                  name="contractType"
                  id="contractType"
                  v-model="contractDetailModal.contractType"
                  :disabled="permissionStatus"
                >
                  <md-option value>Select Type</md-option>
                  <md-option value="fuelType">Fuel Type</md-option>
                  <md-option value="freeKMType">Free KM TYPE</md-option>
                </md-select>
              </md-layout>
              <span class="error" v-if="!contractDetailModal.contractType">{{isContractError}}</span>
            </md-layout>
          </md-layout>
          <md-layout md-gutter style="margin-top:-2%">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <date-picker
              :format="selectDateFormat"
                lang="en"
                v-model="contractDetailModal.fromValidity"
                :disabled="permissionStatus"
                id="Date"
              ></date-picker>
              <span class="error" v-if="!contractDetailModal.fromValidity">{{isFromValidtyError}}</span>
            </md-layout>

            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <date-picker
              :format="selectDateFormat"
                lang="en"
                v-model="contractDetailModal.toValidity"
                :disabled="permissionStatus"
                id="Date"
              ></date-picker>
              <span class="error" v-if="!contractDetailModal.toValidity">{{isToValidtyError}}</span>
            </md-layout>
          </md-layout>

          <md-layout md-gutter>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="35">
              <md-layout md-flex="100">
                <label>Monthly fixed rental for each dedicated vehicle</label>
                <b-form-input :formatter="capitalizeAll"
                  id="monthlyRent"
                  name="monthlyRent"
                  v-model="contractDetailModal.monthlyRent"
                  :disabled="permissionStatus"
                ></b-form-input>
              </md-layout>
              <span class="error" v-if="!contractDetailModal.monthlyRent">{{isMonthlyRentError}}</span>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Number of dedicated vehicles</label>
                <b-form-input :formatter="capitalizeAll"
                  type="number"
                  min="0"
                  id="noOfTrucks"
                  name="noOfTrucks"
                  v-model="contractDetailModal.noOfTrucks"
                  :disabled="permissionStatus"
                ></b-form-input>
              </md-layout>

              <span class="error" v-if="!contractDetailModal.noOfTrucks">{{noOfTrucksError}}</span>
            </md-layout>
          </md-layout>

          <md-layout
            md-gutter
            class="mrgtop-2per"
            v-if="contractDetailModal.contractType=='freeKMType'"
          >
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <label>Free Kilometer per vehicle per months</label>
                <b-form-input :formatter="capitalizeAll"
                  id="allowedKm"
                  name="allowedKm"
                  v-model="contractDetailModal.allowedKm"
                  :disabled="permissionStatus"
                ></b-form-input>
              </md-layout>

              <span class="error" v-if="!contractDetailModal.allowedKm">{{isAllowedKmError}}</span>
            </md-layout>
            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="15">
              <md-layout md-flex="100">
                <label>Vehicle Modal</label>
                <b-form-input :formatter="capitalizeAll"
                  id="vehicleModal"
                  name="vehicleModal"
                  v-model="contractDetailModal.vehicleModal"
                  :disabled="permissionStatus"
                ></b-form-input>
              </md-layout>

              <span class="error" v-if="!contractDetailModal.vehicleModal">{{vehicleModalError}}</span>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="15">
              <md-layout md-flex="100">
                <label for="Type">Vehicle Type</label>
                <md-select
                  name="vehicleType"
                  id="vehicleType"
                  v-model="contractDetailModal.vehicleType"
                >
                  <md-option value>Select Type</md-option>
                  <md-option
                    v-for="(item,index) in vehicleTypeMaster"
                    :key="index"
                    :value="item.vehicleTypeId"
                  >{{item.vehicleType}}</md-option>
                </md-select>
              </md-layout>

              <span class="error" v-if="!contractDetailModal.vehicleType">{{vehicleTypeError}}</span>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="15">
              <md-layout md-flex="100">
                <label>Gross Weight</label>
                <b-form-input :formatter="capitalizeAll"
                  id="grossWeight"
                  name="grossWeight"
                  v-model="contractDetailModal.grossWeight"
                  :disabled="permissionStatus"
                ></b-form-input>
              </md-layout>

              <span class="error" v-if="!contractDetailModal.grossWeight">{{grossWeightError}}</span>
            </md-layout>
          </md-layout>

          <md-layout
            md-gutter
            class="mrgtop-2per"
            v-if="contractDetailModal.contractType=='freeKMType'"
          >
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <label>Additional charges over allowed Km</label>
                <b-form-input :formatter="capitalizeAll"
                  id="overcharges"
                  name="overcharges"
                  v-model="contractDetailModal.overcharges"
                  :disabled="permissionStatus"
                ></b-form-input>
              </md-layout>
              <span class="error" v-if="!contractDetailModal.overcharges">{{isOverChargesError}}</span>
            </md-layout>
            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="5"></md-layout>
          </md-layout>

          <md-layout md-gutter class="mrgtop-2per">
            <md-layout md-flex="45"></md-layout>
            <md-layout md-flex="55">
              <md-button
                class="md-raised md-primary md-button-color"
                :disabled="permissionStatus"
                @click="addContract"
                id="addButtonLoader"
              >Update</md-button>
              <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>

              <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
            </md-layout>
          </md-layout>
        </form>
      </md-card-content>
    </md-card>

    <md-dialog class="HereDialog" md-open-from="#custom" md-close-to="#custom" ref="dialog2">
      <md-dialog-content>
        <div class="box">
          <!-- /.box-header -->
          <div class="box-body"></div>
          <!-- /.box-body -->
        </div>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary">Ok</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
      @close="onClose"
    ></md-dialog-alert>
  </div>
</template>


<script>
import Vue from "vue";
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../../helper/filters";

export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/viewHireContract");

      this.getTypeSize();

      if (
        this.$sessionsStorage.get("editContractId") != "" &&
        this.$sessionsStorage.get("editContractId") != undefined
      ) {
        this.viewContract();
      }
    } else {
      this.$router.push({
        path: "/Login/"
      });
    }
  },
  data() {
    return {
      selectDateFormat,
      permissionStatus:
        this.$sessionsStorage.get("PermissionStatus") != "" &&
        this.$sessionsStorage.get("PermissionStatus") &&
        this.$sessionsStorage.get("PermissionStatus") == "Read"
          ? true
          : false,

      vehicleTypeMaster: [],
      alert: {
        content:
          this.$sessionsStorage.get("editClientId") != "" &&
          this.$sessionsStorage.get("editClientId") != undefined
            ? " Data Updated Succesfully"
            : " Added Succesfully ",
        ok: "ok"
      },

      editVar: {
        Inputval:
          this.$sessionsStorage.get("editClientId") != "" &&
          this.$sessionsStorage.get("editClientId") != undefined
            ? "Update"
            : "Add",
        FormVal:
          this.$sessionsStorage.get("editClientId") != "" &&
          this.$sessionsStorage.get("editClientId") != undefined
            ? "Update"
            : "New"
      },
      contractDetailModal: {
        contractId: "",
        clientId: "",
        fromValidity: "",
        toValidity: "",
        contractType: "",
        // contractSeries: "",
        allowedKm: "",
        monthlyRent: "",
        overcharges: "",
        vehicleModal: "",
        vehicleType: "",
        grossWeight: "",
        noOfTrucks: ""
      },
      contractTable: [],

      showSegmentArray: [],
      showDocumentArray: [],
      stateDetail: [],
      clientError: "",
      corporateAddressError: "",
      stateError: "",
      panNOError: "",
      segmentError: "",
      phoneKYCError: "",
      tanNOError: "",
      GSTNError: "",
      GSTNErrorValid: "",
      isContractError: "",
      isContractError1: "",
      hireContractError: "",
      isFromValidtyError: "",
      isToValidtyError: "",
      isContractError: "",
      isOverChargesError: "",
      hireContractError: "",
      isAllowedKmError: "",
      noOfTrucksError: "",
      vehicleModalError: "",
      vehicleTypeError: "",
      grossWeightError: "",

      isMonthlyRentError: "",
      validate: true,
      count: 0
    };
  },

  mounted() {},
  beforeDestroy() {
    this.$sessionsStorage.set("editContractId", "");
    this.$sessionsStorage.set(
      "editClientId",
      this.contractDetailModal.clientId
    );
  },
  destroyed() {},
  components: {
    DatePicker
  },
  computed: {
    viewKycDoc() {
      return this.clientDetail.uploadKYC.split(",");
    }
  },
  watch: {
    clientDetail: {
      handler(newVal, oldVal) {
        if (newVal.hasOwnProperty("GSTN", "panNO", "tanNO")) {
          // console.log("here>>>", newVal.GSTN.toUpperCase());
          this.clientDetail.GSTN = newVal.GSTN.toUpperCase();
          this.clientDetail.panNO = newVal.panNO.toUpperCase();
          this.clientDetail.tanNO = newVal.tanNO.toUpperCase();
        }
      },
      deep: true
    }
  },
  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },
  methods: {
    getTypeSize() {
      let type_Size = {
        truckTS: "truckTS"
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/fetchTypeSizeTruck.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            this.vehicleTypeMaster = data.truckTypeDetails;
            // this.vehicleSizeMaster = data.truckSizeDetails;
          }
        })
        .catch(error => {});
    },

    onClose(type) {
      this.$sessionsStorage.set(
        "editClientId",
        this.contractDetailModal.clientId
      );
      this.$sessionsStorage.set("editContractId", "");
      this.$router.push({
        path: "/client/addClient"
      });
    },
    previousClientView() {
      this.$sessionsStorage.set(
        "editClientId",
        this.contractDetailModal.clientId
      );
      this.$router.push({
        path: "/client/addClient"
        // params:{
        //   "userId":res.data.Id,
        // }
      });
    },
    hireModel() {
      // this.$router.push({
      //   path: "/listView/hireModel"
      // });
    },

    viewContract() {
      let edit_Client = {
        edit: "edit",
        contractId: this.$sessionsStorage.get("editContractId")
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_TPTContract/viewEditContract.php`,
        data: JSON.stringify(edit_Client),

        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          let array = [];
          let array1 = [];

          if ( status == 200 && data) {
            console.log(data);
            Object.keys(data.editClient[0]).map(x => {
              this.contractDetailModal[x] = data.editClient[0][x] || "";
            });
          }
        })
        .catch(error => {});
    },

    validateContract() {
      let validate_new = true;
      if (this.contractDetailModal.fromValidity == "") {
        $("#fromValidity").focus();
        this.isFromValidtyError = "Select Validity Date";
        validate_new = false;
      }

      if (this.contractDetailModal.toValidity == "") {
        $("#toValidity").focus();
        this.isToValidtyError = "Select Validity Date";
        validate_new = false;
      }
      if (this.contractDetailModal.contractType == "") {
        $("#contractType").focus();
        this.isContractError = "Select Contract Type";
        validate_new = false;
      }

      if (this.contractDetailModal.monthlyRent == "") {
        $("#monthlyRent").focus();
        this.isMonthlyRentError = "Enter Monthly Month";
        validate_new = false;
      }

      if (
        this.contractDetailModal.contractType == "freeKMType" &&
        this.contractDetailModal.allowedKm == ""
      ) {
        $("#allowedKm").focus();
        this.isAllowedKmError = "Enter Allowed Kilometer";
        validate_new = false;
      }

      if (this.contractDetailModal.noOfTrucks == "") {
        $("#noOfTrucks").focus();
        this.noOfTrucksError = "Enter No. of Trucks";
        validate_new = false;
      }
      if (
        this.contractDetailModal.contractType == "freeKMType" &&
        this.contractDetailModal.vehicleType == ""
      ) {
        $("#vehicleType").focus();
        this.vehicleTypeError = "Select Vehicle Type";
        validate_new = false;
      }
      if (
        this.contractDetailModal.contractType == "freeKMType" &&
        this.contractDetailModal.vehicleModal == ""
      ) {
        $("#vehicleModal").focus();
        this.vehicleModalError = "Select vehicle Modal";
        validate_new = false;
      }
      if (
        this.contractDetailModal.contractType == "freeKMType" &&
        this.contractDetailModal.grossWeight == ""
      ) {
        $("#grossWeight").focus();
        this.grossWeightError = "Enter Gross Weight";
        validate_new = false;
      }

      if (
        this.contractDetailModal.contractType == "freeKMType" &&
        this.contractDetailModal.overcharges == ""
      ) {
        $("#overcharges").focus();
        this.isOverChargesError = "Enter OverChages";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    openContractDialog() {
      this.$refs["dialog2"].open();
    },

    addContract() {
      this.validateContract();
      if (this.validate != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");

        this.$refs["dialog2"].close();
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_TPTContract/addContractDetail.php`,
          data: JSON.stringify(this.contractDetailModal),

          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {
              $("#addButtonLoader").css("display", "block");
              $("#loader").css("display", "none");
              this.alert.content = "Updated Succesfully";
              this.$refs["addPop"].open();
            }
          })
          .catch(error => {});
      }
    },

    getSegmentData() {}
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 2%;
}
.mrgtop-3per {
  margin-top: 4%;
}
.mrgtop-5px {
  margin-top: 5px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 5px !important;
}

h3 {
  margin: 0px !important;
}
.margn-0px {
  margin: 0px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}
.error {
  color: red;
}
.md-dialog-container.HereDialog.md-theme-default {
  z-index: 999999;
}

.md-dialog-container.HereDialog.md-theme-default .md-dialog {
  width: 100%;
  height: 80%;
}
.md-select-content {
  z-index: 999999999;
}
</style>


// WEBPACK FOOTER //
// viewHireContract.vue?2a48e56c